<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>题库管理</el-breadcrumb-item>
      <el-breadcrumb-item>答题结果</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">答题结果</span>
      </div>

      <!-- 筛选区 -->
      <div class="search-bar">
        <el-form :model="queryInfo" :inline="true" size="small" label-width="80px">
          <el-form-item label="选择测试">
            <el-select
              v-model="queryInfo.examId"
              placeholder="请选择测试"
              clearable
              style="width: 240px;"
              @change="handleExamChange">
              <el-option v-for="item in examList" :key="item._id" :label="item.title" :value="item._id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              v-model="queryInfo.name"
              placeholder="请输入姓名"
              clearable
              style="width: 160px;"
              @clear="handleSearch"
              @keyup.enter.native="handleSearch">
            </el-input>
          </el-form-item>
          <el-form-item label="所属项目">
            <el-input
              v-model="queryInfo.projectName"
              placeholder="请输入项目名称"
              clearable
              style="width: 180px;"
              @clear="handleSearch"
              @keyup.enter.native="handleSearch">
            </el-input>
          </el-form-item>
          <el-form-item label="是否通过">
            <el-select
              v-model="queryInfo.passed"
              placeholder="全部"
              clearable
              style="width: 120px;"
              @change="handleSearch">
              <el-option label="通过" value="true"></el-option>
              <el-option label="未通过" value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提交时间">
            <el-date-picker
              v-model="queryInfo.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 260px;"
              @change="handleSearch">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据表格 -->
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column type="index" label="#" width="60"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="120"></el-table-column>
        <el-table-column prop="projectName" label="所属项目" min-width="120"></el-table-column>
        <el-table-column label="所属测试" min-width="180">
          <template slot-scope="scope">
            {{ getExamTitle(scope.row.exam) }}
          </template>
        </el-table-column>
        <el-table-column label="得分" width="120">
          <template slot-scope="scope">
            {{ scope.row.score }}分
          </template>
        </el-table-column>
        <el-table-column label="是否通过" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.passed ? 'success' : 'danger'" size="small">
              {{ scope.row.passed ? '通过' : '未通过' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" width="180">
          <template slot-scope="scope">{{ scope.row.submitTime | dateFormat }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleViewDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <!-- 答题详情对话框 -->
    <el-dialog
      title="答题详情"
      :visible.sync="detailDialogVisible"
      width="700px"
      :close-on-click-modal="false">
      <div v-if="detailData" class="detail-content">
        <!-- 顶部信息 -->
        <div class="detail-header">
          <el-descriptions :column="3" border size="medium">
            <el-descriptions-item label="姓名">{{ detailData.record.name }}</el-descriptions-item>
            <el-descriptions-item label="得分">{{ detailData.record.score }}/{{ detailData.exam.totalScore }}</el-descriptions-item>
            <el-descriptions-item label="是否通过">
              <el-tag :type="detailData.record.passed ? 'success' : 'danger'" size="small">
                {{ detailData.record.passed ? '通过' : '未通过' }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 逐题展示 -->
        <div class="detail-questions">
          <div v-for="(item, index) in detailData.details" :key="index" class="question-item">
            <el-card shadow="hover" class="question-card">
              <!-- 题目标题 -->
              <div class="question-title">
                <span class="question-index">第 {{ index + 1 }} 题</span>
                <span :class="item.correct ? 'icon-correct' : 'icon-wrong'">
                  {{ item.correct ? '✓' : '✗' }}
                </span>
              </div>

              <!-- 题目内容 -->
              <div class="question-content">
                <template v-if="item.question && item.question.content && item.question.content.contentType === 'image'">
                  <el-image
                    :src="base + item.question.content.value"
                    fit="contain"
                    style="max-width: 100%; max-height: 200px;">
                  </el-image>
                </template>
                <template v-else>
                  <p>{{ item.question && item.question.content ? item.question.content.value : '' }}</p>
                </template>
              </div>

              <!-- 选项列表 -->
              <div v-if="item.question && item.question.options && item.question.options.length > 0" class="question-options">
                <div
                  v-for="(opt, optIdx) in item.question.options"
                  :key="optIdx"
                  class="option-item"
                  :class="{
                    'option-user-selected': isUserSelected(item, optIdx),
                    'option-correct': isCorrectAnswer(item, optIdx),
                    'option-wrong-selected': isUserSelected(item, optIdx) && !isCorrectAnswer(item, optIdx)
                  }">
                  <span class="option-label">{{ optionLabels[optIdx] }}.</span>
                  <template v-if="opt.contentType === 'image'">
                    <el-image :src="base + opt.value" fit="contain" style="max-width: 120px; max-height: 60px;"></el-image>
                  </template>
                  <template v-else>
                    <span>{{ opt.value }}</span>
                  </template>
                  <span v-if="isUserSelected(item, optIdx)" class="option-tag user-tag">用户选择</span>
                  <span v-if="isCorrectAnswer(item, optIdx)" class="option-tag correct-tag">正确答案</span>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RecordList',
  data () {
    return {
      // 列表数据
      list: [],
      total: 0,
      loading: false,
      // 测试列表（供筛选）
      examList: [],
      // 查询条件
      queryInfo: {
        examId: '',
        name: '',
        projectName: '',
        passed: '',
        dateRange: [],
        pagenum: 1,
        pagesize: 20
      },
      // 详情弹窗
      detailDialogVisible: false,
      // 详情数据
      detailData: null,
      // 图片基础路径
      base: '',
      // 选项标签
      optionLabels: ['A', 'B', 'C', 'D', 'E', 'F']
    }
  },
  created () {
    this.base = window.sessionStorage.getItem('base') || ''
    // 从 URL 参数中获取 examId
    const examId = this.$route.query.examId
    if (examId) {
      this.queryInfo.examId = examId
    }
    this.getExamList()
    this.getList()
  },
  methods: {
    // ========== 数据获取 ==========

    /** 获取测试列表（供筛选） */
    async getExamList () {
      try {
        const { data: res } = await this.$http.get('tiku/exam/list', {
          params: { pagenum: 1, pagesize: 1000 }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.examList = res.data.list
      } catch (error) {
        this.$message.error('获取测试列表失败')
      }
    },

    /** 获取答题记录列表 */
    async getList () {
      this.loading = true
      try {
        const params = {
          examId: this.queryInfo.examId,
          name: this.queryInfo.name,
          projectName: this.queryInfo.projectName,
          passed: this.queryInfo.passed,
          startTime: this.queryInfo.dateRange && this.queryInfo.dateRange[0] ? this.queryInfo.dateRange[0] : '',
          endTime: this.queryInfo.dateRange && this.queryInfo.dateRange[1] ? this.queryInfo.dateRange[1] : '',
          pagenum: this.queryInfo.pagenum,
          pagesize: this.queryInfo.pagesize
        }
        const { data: res } = await this.$http.get('tiku/record/list', { params })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.list = res.data.list
        this.total = res.data.total
      } catch (error) {
        this.$message.error('获取答题记录失败')
      } finally {
        this.loading = false
      }
    },

    // ========== 筛选与分页 ==========

    /** 根据测试ID获取测试名称 */
    getExamTitle (examId) {
      if (!examId) return '-'
      const exam = this.examList.find(item => item._id === examId)
      return exam ? exam.title : '-'
    },

    /** 触发查询（重置页码到第 1 页） */
    handleSearch () {
      this.queryInfo.pagenum = 1
      this.getList()
    },

    /** 测试选择变更 */
    handleExamChange () {
      this.queryInfo.pagenum = 1
      this.getList()
    },

    /** 重置筛选条件 */
    resetQuery () {
      this.queryInfo = {
        examId: '',
        name: '',
        projectName: '',
        passed: '',
        dateRange: [],
        pagenum: 1,
        pagesize: this.queryInfo.pagesize
      }
      this.getList()
    },

    /** 每页数量变更 */
    handleSizeChange (val) {
      this.queryInfo.pagesize = val
      this.getList()
    },

    /** 页码变更 */
    handleCurrentChange (val) {
      this.queryInfo.pagenum = val
      this.getList()
    },

    // ========== 答题详情 ==========

    /** 查看答题详情 */
    async handleViewDetail (row) {
      try {
        const { data: res } = await this.$http.get(`tiku/record/detail/${row._id}`)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.detailData = res.data
        this.detailDialogVisible = true
      } catch (error) {
        this.$message.error('获取答题详情失败')
      }
    },

    /** 判断选项是否为用户选择 */
    isUserSelected (item, optIdx) {
      if (!item.userAnswer) return false
      return item.userAnswer.includes(optIdx)
    },

    /** 判断选项是否为正确答案 */
    isCorrectAnswer (item, optIdx) {
      if (!item.correctAnswer) return false
      return item.correctAnswer.includes(optIdx)
    }
  }
}
</script>

<style lang="less" scoped>
.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardHeader {
  font-size: 18px;
  font-weight: bold;
}

.search-bar {
  margin-bottom: 15px;
  padding: 20px 20px 0;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.el-pagination {
  margin-top: 15px;
}

.detail-content {
  .detail-header {
    margin-bottom: 20px;
  }

  .detail-questions {
    max-height: 500px;
    overflow-y: auto;
    padding-right: 10px;
  }

  .question-item {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .question-card {
    .question-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .question-index {
        font-weight: bold;
        font-size: 15px;
        color: #303133;
      }

      .icon-correct {
        color: #67c23a;
        font-size: 20px;
        font-weight: bold;
      }

      .icon-wrong {
        color: #f56c6c;
        font-size: 20px;
        font-weight: bold;
      }
    }

    .question-content {
      margin-bottom: 12px;
      font-size: 14px;
      color: #303133;
      line-height: 1.6;
    }

    .question-options {
      .option-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        margin-bottom: 6px;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        background-color: #fafafa;
        font-size: 14px;

        &:last-child {
          margin-bottom: 0;
        }

        .option-label {
          font-weight: bold;
          margin-right: 8px;
          min-width: 24px;
        }

        .option-tag {
          margin-left: auto;
          font-size: 12px;
          padding: 2px 6px;
          border-radius: 3px;
        }

        .user-tag {
          background-color: #e6a23c;
          color: #fff;
        }

        .correct-tag {
          background-color: #67c23a;
          color: #fff;
        }
      }

      // 用户选择且正确的选项
      .option-correct {
        background-color: #f0f9eb;
        border-color: #b3e19d;
      }

      // 用户选择但错误的选项
      .option-wrong-selected {
        background-color: #fef0f0;
        border-color: #fbc4c4;
      }

      // 用户选择的选项
      .option-user-selected {
        background-color: #fdf6ec;
        border-color: #f5dab1;
      }
    }
  }
}
</style>
